import { clamp } from './format';

export interface QualityInfo {
  label: string;
  cls: string;
}

export function qualityFromFps(fps: number): QualityInfo {
  if (!isFinite(fps)) return { label: '—', cls: '' };
  if (fps >= 45) return { label: 'GOOD', cls: 'text-good' };
  if (fps >= 30) return { label: 'OK', cls: 'text-ok' };
  return { label: 'POOR', cls: 'text-bad' };
}

export function qualityFromTime(ms: number | null | undefined, good: number, ok: number): QualityInfo {
  if (ms == null || !isFinite(ms)) return { label: '—', cls: '' };
  if (ms <= good) return { label: 'GOOD', cls: 'text-good' };
  if (ms <= ok) return { label: 'OK', cls: 'text-ok' };
  return { label: 'POOR', cls: 'text-bad' };
}

export function scoreFromFps(fps: number): number {
  if (!isFinite(fps)) return 0;
  return clamp(((fps - 10) / (60 - 10)) * 100, 0, 100);
}

export function scoreFromTime(ms: number | null | undefined, good: number, ok: number): number {
  if (ms == null || !isFinite(ms)) return 0;
  if (ms <= good) return 100;
  if (ms <= ok) return 70;
  const worst = ok * 4;
  const t = clamp((ms - ok) / (worst - ok), 0, 1);
  return Math.round(70 - t * 60);
}

export function scoreChipClass(score: number | null): string {
  if (score == null) return 'border-border text-muted';
  if (score >= 75) return 'border-good/45 bg-good/25 text-green-100';
  if (score >= 55) return 'border-ok/55 bg-ok/25 text-yellow-100';
  return 'border-bad/55 bg-bad/20 text-red-100';
}
